<div class="viewer-toolbar">

  <button type="button" class="viewer-toolbar-action viewer-toolbar-back" *ngIf="showBack"
          (click)="back.emit()"
          [attr.aria-label]="backLabelKey | translate">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
    </svg>
    <span>{{ backLabelKey | translate }}</span>
  </button>

  <div class="viewer-toolbar-heading">
    <div class="viewer-toolbar-title-row">
      <h3 class="viewer-toolbar-title">{{ title }}</h3>
      <!-- Marca propia de cada pantalla, pegada al título -->
      <ng-content select="[viewerToolbarTitleAddon]"></ng-content>
    </div>
    <small class="viewer-toolbar-description" *ngIf="description">{{ description }}</small>
    <!-- Nota propia de cada pantalla, debajo del título -->
    <ng-content select="[viewerToolbarNote]"></ng-content>
  </div>

  <!-- Pantalla completa. El elemento que se expande lo maneja la pantalla, no la barra -->
  <button type="button" class="viewer-toolbar-action viewer-toolbar-fullscreen" *ngIf="showFullscreen"
          (click)="fullscreenToggle.emit()"
          [attr.aria-label]="isFullscreen
            ? ('COMMON.ACTIONS.EXIT_FULL_SCREEN' | translate)
            : ('COMMON.ACTIONS.FULL_SCREEN' | translate)">
    <svg *ngIf="!isFullscreen" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/>
      <line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/>
    </svg>
    <svg *ngIf="isFullscreen" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/>
      <line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/>
    </svg>
    <span>{{ isFullscreen
      ? ('COMMON.ACTIONS.EXIT_FULL_SCREEN' | translate)
      : ('COMMON.ACTIONS.FULL_SCREEN' | translate) }}</span>
  </button>

  <!-- Compartir: qué se comparte lo resuelve cada pantalla -->
  <button type="button" class="viewer-toolbar-action viewer-toolbar-share" *ngIf="showShare"
          (click)="share.emit()"
          [attr.aria-label]="shareLabelKey | translate">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
      <polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/>
    </svg>
    <span>{{ shareLabelKey | translate }}</span>
  </button>

  <!-- Muchos sitios no permiten ser incrustados: siempre queda la salida de abrirlo aparte -->
  <a class="viewer-toolbar-action viewer-toolbar-open" *ngIf="showOpenInNewTab && openInNewTabUrl"
     [href]="openInNewTabUrl" target="_blank" rel="noopener noreferrer">
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
      <polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
    </svg>
    <span>{{ openInNewTabLabel }}</span>
  </a>

  <!-- Acciones propias de cada pantalla, las que no comparte con las demás -->
  <ng-content></ng-content>

</div>
